import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { DocumentTaskListResponse } from '@/api/client';
import { getTransitionDocumentTasksv1ApiTransitionsTransitionIdDocumentTasksGet } from '@/api/client';

export const transitionDocumentTasksQueryKey = (transitionId: string) =>
  ['transition-document-tasks', transitionId] as const;

const DEFAULT_LIMIT = 500;

export const useTransitionDocumentTasks = (
  transitionId: string | undefined,
  options?: Omit<
    UseQueryOptions<DocumentTaskListResponse>,
    'queryKey' | 'queryFn' | 'enabled'
  >
) => {
  return useQuery({
    queryKey: transitionDocumentTasksQueryKey(transitionId ?? ''),
    queryFn: () =>
      getTransitionDocumentTasksv1ApiTransitionsTransitionIdDocumentTasksGet(
        { transitionId: transitionId! },
        { limit: DEFAULT_LIMIT, offset: 0 }
      ),
    enabled: Boolean(transitionId),
    staleTime: 60 * 1000,
    ...options,
  });
};
